import { TLPS_LIST, TLPS_LIST_SUCCESS, TLPS_LIST_ERROR }  from './constants';
import { DAILY_CPS_LIST, DAILY_CPS_LIST_SUCCESS, DAILY_CPS_LIST_ERROR }  from './constants';

export default function dailyCPSReducer(state, action) {
	let tlps = [];
	let cps = [];
  
	switch (action.type) {
	case TLPS_LIST:
		return { ...state, loading: true, error: false };

	case TLPS_LIST_SUCCESS:
		

		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map( (item) => {
				let data = {};

				data.id = item.id ? item.id : 0;
				data.deviceId = item.deviceId ? item.deviceId : 0;
				data.pipelineChainage = item.pipelineChainage ? parseFloat(item.pipelineChainage)/1000 : 0;

				return tlps.push(data);
			});

			let sortedTLPS = tlps.sort(function(a, b) {
				return parseInt(a.pipelineChainage) - parseInt(b.pipelineChainage);
			});

			return { ...state, tlps: sortedTLPS, loading: false, error: false };
		} else {
			return { ...state, tlps : [], loading: false, error: true };
		}

	case TLPS_LIST_ERROR:
		return { ...state, loading: false, error: true };
        
	case DAILY_CPS_LIST:
		return { ...state, loading: true };

	case DAILY_CPS_LIST_SUCCESS:
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map( (item) => {
				let data = {};

				data.id = item.id ? parseInt(item.id) : 0;
				data.pipelineId = item.pipelineId ? item.pipelineId : 0;
				data.pipelineChainage = item.pipelineChainage ?  parseFloat(item.pipelineChainage)/1000 : 0;
				data.deviceId = item.deviceId ?  item.deviceId : 0;
				data.tlpId = item.tlpId ?  item.tlpId : 0;
				data.datetime = item.datetime ? item.datetime : null;
            
				data.vac1 = item.vac1 ? parseFloat(item.vac1).toFixed(2) : 0;
				data.vac2 = item.vac2 ? parseFloat(item.vac2).toFixed(2) : 0;
				data.vdc1 = item.vdc1 ? parseFloat(item.vdc1).toFixed(2) : 0;
				data.vdc2 = item.vdc2 ? parseFloat(item.vdc2).toFixed(2) : 0;

				data.vac1Normal = item.vac1Normal ?(item.vac1Normal) : 0;
				data.vac2Normal = item.vac2Normal ? (item.vac2Normal) : 0;
				data.vdc1Normal = item.vdc1Normal ? (item.vdc1Normal) : 0;
				data.vdc2Normal = item.vdc2Normal ? (item.vdc2Normal): 0;

				data.offPSPacNormal = item.offPSPacNormal ? (item.offPSPacNormal) : 0;
				data.offPSPdcNormal = item.offPSPdcNormal ? (item.offPSPdcNormal) : 0;

				data.offCSPacNormal = item.offCSPacNormal ? (item.offCSPacNormal) : 0;
				data.offCSPdcNormal = item.offCSPdcNormal ? (item.offCSPdcNormal) : 0;
            
				data.vac1Min = data.vac1Normal ? parseFloat(data.vac1Normal.split(':')[0]).toFixed(2) : 0;
				data.vac1Max = data.vac1Normal ? parseFloat(data.vac1Normal.split(':')[1]).toFixed(2) : 0;
				data.vdc1Min = data.vdc1Normal ? parseFloat(data.vdc1Normal.split(':')[0]).toFixed(2) : 0;
				data.vdc1Max = data.vdc1Normal ? parseFloat(data.vdc1Normal.split(':')[1]).toFixed(2) : 0;
				data.vac2Min = data.vac2Normal ? parseFloat(data.vac2Normal.split(':')[0]).toFixed(2) : 0;
				data.vac2Max = data.vac2Normal ? parseFloat(data.vac2Normal.split(':')[1]).toFixed(2) : 0;
				data.vdc2Min = data.vdc2Normal ? parseFloat(data.vdc2Normal.split(':')[0]).toFixed(2) : 0;
				data.vdc2Max = data.vdc2Normal ? parseFloat(data.vdc2Normal.split(':')[1]).toFixed(2) : 0;

				data.currentAc = item.currentAc ? parseFloat(item.currentAc).toFixed(2) : 0;
				data.currentDc = item.currentDc ? parseFloat(item.currentDc).toFixed(2) : 0;
				
				data.offPSPac = item.offPSPac ? parseFloat(item.offPSPac).toFixed(2) : 0;
				data.offPSPacMin = data.offPSPacNormal ? parseFloat(data.offPSPacNormal.split(':')[0]).toFixed(2) : 0;
				data.offPSPacMax = data.offPSPacNormal ? parseFloat(data.offPSPacNormal.split(':')[1]).toFixed(2) : 0;
				data.offPSPdc = item.offPSPdc ? parseFloat(item.offPSPdc).toFixed(2) : 0;
				data.offPSPdcMin = data.offPSPdcNormal ? parseFloat(data.offPSPdcNormal.split(':')[0]).toFixed(2) : 0;
				data.offPSPdcMax = data.offPSPdcNormal ? parseFloat(data.offPSPdcNormal.split(':')[1]).toFixed(2) : 0;	
				
				data.offCSPac = item.offCSPac ? parseFloat(item.offCSPac).toFixed(2) : 0;
				data.offCSPacMin = data.offCSPacNormal ? parseFloat(data.offCSPacNormal.split(':')[0]).toFixed(2) : 0;
				data.offCSPacMax = data.offCSPacNormal ? parseFloat(data.offCSPacNormal.split(':')[1]).toFixed(2) : 0;
				data.offCSPdc = item.offCSPdc ? parseFloat(item.offCSPdc).toFixed(2) : 0;
				data.offCSPdcMin = data.offCSPdcNormal ? parseFloat(data.offCSPdcNormal.split(':')[0]).toFixed(2) : 0;
				data.offCSPdcMax = data.offCSPdcNormal ? parseFloat(data.offCSPdcNormal.split(':')[1]).toFixed(2) : 0;			

				data.vbat = item.vbat ? parseFloat(item.vbat).toFixed(2) : 0;
				data.temp = item.temp ? parseFloat(item.temp).toFixed(2) : 0;
				data.current = item.current ? parseFloat(item.current).toFixed(2) : 0;

				return cps.push(data);
			});

			let sortedCPS = cps.sort(function(a, b) {
				return parseInt(a.pipelineChainage) - parseInt(b.pipelineChainage);
			});
          
			return { ...state, cps: sortedCPS, loading: false, error: false };
		} else {
			if (action.payload && action.payload.data && action.payload.data.length === 0) {
				return { ...state, cps: cps, loading: false, error: false };
			} else {
				return { ...state, loading: false, error: true };
			}
		}

	case DAILY_CPS_LIST_ERROR:
		return { ...state, loading: false, error: true };

	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}